import React from 'react';
import { Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Facts from './components/Facts';
import FactArticleContainer from './containers/FactArticleContainer';
import News from './components/News';
import NewsArticleContainer from './containers/NewsArticleContainer';
import Reports from './components/Reports';
import MapContainer from './containers/MapContainer';
import Footer from './components/Footer';
import './utils/Vars.css';
import './utils/Normalizer.css';
import './App.css';

export default () => {
  return (
    <div className="app">
      <Header />
      <Route exact path="/" component={Home} />
      <Route exact path="/verificacion" component={Facts} />
      <Route path={'/verificacion/:id'} component={FactArticleContainer} />
      <Route exact path="/notas" component={News} />
      <Route path={'/notas/:slug'} component={NewsArticleContainer} />
      <Route exact path="/reportes" component={Reports} />
      <Route exact path="/mapa" component={MapContainer} />
      {window.location.pathname !== '/mapa' && <Footer />}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/App.js